export default {
  title: 'Führen Sie Ihr Geschäft von überall aus',
  description: 'Melde dich mit deinem bestehenden Konto an.',
  form: {
    email: {
      label: 'Email',
      placeholder: 'E-Mail eingeben',
    },
    password: {
      label: 'Passwort',
      placeholder: 'Passwort eingeben',
    },
    error_messages: {
      missing_info: 'Fehlende Informationen',
      wrong_credentials: 'Falsche Email oder Passwort',
    },
  },
  buttons: {
    login: 'Login',
    forgot_password: 'Passwort vergessen',
  },
  white_label: {
    title: 'Melden Sie sich in Ihrem Dashboard an',
    form: {
      email: {
        label: 'E-Mail-Adresse',
        placeholder: 'sie@restaurant.de',
      },
      password: {
        label: 'Passwort',
        placeholder: 'Passwort eingeben',
      },
    },
    buttons: {
      login: 'Anmelden',
    },
    intro: {
      eyebrow: 'Bestellverwaltung',
      headline: 'Führen Sie Ihr Restaurant von überall.',
      description: 'Bestellungen, Speisekarten, Öffnungszeiten und Auszahlungen — alles an einem Ort.',
      features: {
        live: {
          title: 'Live',
          subtitle: 'Bestellverfolgung',
        },
        instant: {
          title: 'Sofort',
          subtitle: 'Menüänderungen',
        },
        any_device: {
          title: 'Jedes Gerät',
          subtitle: 'Handy oder Tablet',
        },
      },
    },
  },
};
